import type { AnimationDataV5 } from './types/v5';
import type { AnimationDataV6 } from './types/v6';

/**
 * V5 → V6. Pure additive: `AnimationData` gains optional captions-related
 * fields and an optional `selectedTemplateId: string | null` template
 * override. Legacy V5 saves don't have the fields; they stay `undefined` on
 * upgrade so consumers fall back to the same defaults they had pre-V6.
 */
export function v5ToV6(input: AnimationDataV5): AnimationDataV6 {
    return { ...input, version: 6 };
}
